import React, { useState } from 'react';
import { CheckButton } from '../CheckButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const CheckButtonDemo: React.FC = () => {
    const [selected, setSelected] = useState(false);

    return (
        <>
            <h3>Check Button :</h3>
            <br />
            <CheckButton
                id='save-budget'
                label='CheckButton Demo'
                icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
                selected={selected}
                onToggle={() => setSelected(!selected)}
            />
        </>
    );
};
